import { StepDTO } from 'react-form-stepper/dist/components/Step/StepTypes'
import { BiCircle, BiLoaderCircle } from 'react-icons/bi'

export const DISCARD_BUTTON = 'DISCARD'
export const IGNORE_BUTTON = 'IGNORE'

export const IS_NEW_USER = 'IS_NEW_USER'

export enum UploadStepper {
  selectFile = 0,
  validate = 1,
  exclusions = 2,
  submit = 3,
  closeModel = 5,
}

export const STEPPER_TITLE: StepDTO[] = [
  { label: '1. Select File' },
  { label: '2. Validate' },
  { label: '3. Exclusions' },
  { label: '4. Submit' },
]

export const CLAIM_VALIDATE_TIMER = {
  ONE_SEC: 1000,
  TWO_HALF_SEC: 2500,
  FIVE_SEC: 5000,
  TEN_SEC: 10000,
  TWENTY_SEC: 20000,
}

export const CLAIM_FILE_VALIDATION_CHECK = [
  {
    title: 'Required columns',
    tooltip: `Claim file must include all columns shown in the CSV template (available below the “Upload File” button)`,
  },
  {
    title: 'Required fields',
    tooltip: `Provider NPI, tax ID, patient ID, date of service, patient DOB, unique ID, patient first and last names, account ID, provider name and payer phone number must be present in each row.`,
  },
  {
    title: 'Data format',
    tooltip: `Number-based values must include the proper number of digits.(e.g. NPIs must be 10 digits, Tax IDs must be 9 digits, etc.)`,
  },
  {
    title: 'Claim dollar amounts',
    tooltip: `Claim dollar amounts should be less than $1 million and more than 0.`,
  },
  {
    title: 'Unique IDs',
    tooltip: `Unique IDs must not be repeated across rows in the claim file. All instances of identical “Unique IDs” will be excluded from upload.`,
  },
  {
    title: 'Required PTANs',
    tooltip: `All Medicare claim rows must include a Provider Transaction Access Number (PTAN)`,
  },
]

export const FILE_VALIDATE_PROCESS = {
  count_1: {
    title: 'Validating your claim file',
    progress: 50,
    icon: <BiLoaderCircle className="loader-icon" />,
  },
  count_2: {
    title: 'Almost finished...',
    progress: 80,
    icon: <BiLoaderCircle className="loader-icon" />,
  },
  count_3: {
    title: 'This is taking longer than expected...',
    progress: 80,
    icon: <BiLoaderCircle className="loader-icon" />,
  },
  count_4: {
    title: 'Validation results are ready!',
    progress: 100,
    icon: <BiCircle className="loader-icon" />,
  },
}
